import { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";

export default function Sidebar() {
  const location = useLocation();

  const isRestauranteRoute = ['/mesas', '/para-llevar', '/meseros', '/cocina'].includes(location.pathname);
  const isOrdenarRoute = ['/mesas', '/para-llevar'].includes(location.pathname);
  const isInventarioRoute = ['/products', '/inventory-adjustments'].includes(location.pathname);

  const [restauranteOpen, setRestauranteOpen] = useState(isRestauranteRoute);
  const [ordenarOpen, setOrdenarOpen] = useState(isOrdenarRoute);
  const [inventarioOpen, setInventarioOpen] = useState(isInventarioRoute);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Cerrar sidebar al navegar en tablet
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  // Bloquear scroll del body cuando sidebar está abierto en tablet
  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [sidebarOpen]);

  const isActive = (path) => location.pathname === path ? "active" : "";

  return (
    <>
      {/* Botón hamburguesa */}
      <button className="sidebar-hamburger" onClick={() => setSidebarOpen(!sidebarOpen)}>
        {sidebarOpen ? (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
          </svg>
        ) : (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
          </svg>
        )}
      </button>

      {/* Overlay */}
      <div className={`sidebar-overlay ${sidebarOpen ? 'visible' : ''}`} onClick={() => setSidebarOpen(false)} />

      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <svg width="35" height="35" viewBox="0 0 24 24" fill="none">
              <path d="M9 11L12 14L22 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 21.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h5 className="sidebar-title">ALTIVAWEB</h5>
          <p className="sidebar-subtitle">Sistema de Facturación</p>
        </div>

        <nav className="sidebar-nav">

          {/* POS */}
          <div className="nav-section">
            <Link to="/pos" className={`nav-item nav-item-primary ${isActive("/pos")}`}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
                <path d="M16 21V5C16 4.46957 15.7893 3.96086 15.4142 3.58579C15.0391 3.21071 14.5304 3 14 3H10C9.46957 3 8.96086 3.21071 8.58579 3.58579C8.21071 3.96086 8 4.46957 8 5V21" stroke="currentColor" strokeWidth="2"/>
              </svg>
              <span>Punto de Venta</span>
            </Link>
          </div>

          <div className="nav-divider"></div>

          {/* Restaurante */}
          <div className="nav-section">
            <button className={`nav-item nav-collapse-trigger ${isRestauranteRoute ? 'active' : ''}`} onClick={() => setRestauranteOpen(!restauranteOpen)}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C12 2 8 6 8 10C8 12.2 9.8 14 12 14C14.2 14 16 12.2 16 10C16 6 12 2 12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8 22V14M16 22V14M5 22H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              <span>Restaurante</span>
              <svg className={`collapse-arrow ${restauranteOpen ? 'open' : ''}`} width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ marginLeft: 'auto' }}>
                <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            <div className={`nav-submenu ${restauranteOpen ? 'open' : ''}`}>
              <button className={`nav-item nav-subitem nav-collapse-trigger ${isOrdenarRoute ? 'active' : ''}`} onClick={() => setOrdenarOpen(!ordenarOpen)}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15M9 5C9 5.55228 9.44772 6 10 6H14C14.5523 6 15 5.55228 15 5M9 5C9 4.44772 9.44772 4 10 4H14C14.5523 4 15 4.44772 15 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                <span>Ordenar</span>
                <svg className={`collapse-arrow ${ordenarOpen ? 'open' : ''}`} width="12" height="12" viewBox="0 0 24 24" fill="none" style={{ marginLeft: 'auto' }}>
                  <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>

              <div className={`nav-submenu ${ordenarOpen ? 'open' : ''}`}>
                <Link to="/mesas" className={`nav-item nav-subitem nav-subsubitem ${isActive("/mesas")}`}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                    <path d="M3 5H21M3 12H21M3 19H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <rect x="6" y="8" width="12" height="8" rx="1" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  <span>Mesas</span>
                </Link>
                <Link to="/para-llevar" className={`nav-item nav-subitem nav-subsubitem ${isActive("/para-llevar")}`}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                    <path d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8l1 12a2 2 0 002 2h8a2 2 0 002-2L19 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Para Llevar / Delivery</span>
                </Link>
              </div>

              <Link to="/meseros" className={`nav-item nav-subitem ${isActive("/meseros")}`}>
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
                </svg>
                <span>Meseros</span>
              </Link>

              <Link to="/cocina" className={`nav-item nav-subitem ${isActive("/cocina")}`}>
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2C12 2 8 6 8 10C8 12.2 9.8 14 12 14C14.2 14 16 12.2 16 10C16 6 12 2 12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M8 22V14M16 22V14M5 22H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                <span>Vista Cocina</span>
              </Link>
            </div>
          </div>

          <div className="nav-divider"></div>

          {/* Caja */}
          <div className="nav-section">
            <div className="nav-section-title">Caja</div>
            <Link to="/cash" className={`nav-item ${isActive("/cash")}`}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
                <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth="2"/>
                <path d="M18.5 9V15M5.5 9V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              <span>Control de Caja</span>
            </Link>
            <Link to="/cash/history" className={`nav-item ${isActive("/cash/history")}`}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M12 8V12L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
              </svg>
              <span>Historial de Caja</span>
            </Link>
          </div>

          <div className="nav-divider"></div>

          {/* Operaciones */}
          <div className="nav-section">
            <div className="nav-section-title">Operaciones</div>
            <Link to="/purchase" className={`nav-item ${isActive("/purchase")}`}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M6 2L3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6L18 2H6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M3 6H21M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Compras</span>
            </Link>
            <Link to="/invoices" className={`nav-item ${isActive("/invoices")}`}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M14 2V8H20M16 13H8M16 17H8M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              <span>Facturas (DTE)</span>
            </Link>
            <Link to="/credit-notes" className={`nav-item ${isActive("/credit-notes")}`}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M9 11L12 14L22 4M21 12V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Notas de Crédito</span>
            </Link>
          </div>

          <div className="nav-divider"></div>

          {/* Catálogos */}
          <div className="nav-section">
            <div className="nav-section-title">Catálogos</div>
            <Link to="/clients" className={`nav-item ${isActive("/clients")}`}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
                <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Clientes</span>
            </Link>

            <button className={`nav-item nav-collapse-trigger ${isInventarioRoute ? 'active' : ''}`} onClick={() => setInventarioOpen(!inventarioOpen)}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M21 16V8C20.9996 7.64927 20.9071 7.30481 20.7315 7.00116C20.556 6.69751 20.3037 6.44536 20 6.27L13 2.27C12.696 2.09446 12.3511 2.00205 12 2.00205C11.6489 2.00205 11.304 2.09446 11 2.27L4 6.27C3.69626 6.44536 3.44398 6.69751 3.26846 7.00116C3.09294 7.30481 3.00036 7.64927 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M3.27 6.96L12 12.01L20.73 6.96M12 22.08V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Inventario</span>
              <svg className={`collapse-arrow ${inventarioOpen ? 'open' : ''}`} width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ marginLeft: 'auto' }}>
                <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            <div className={`nav-submenu ${inventarioOpen ? 'open' : ''}`}>
              <Link to="/products" className={`nav-item nav-subitem ${isActive("/products")}`}>
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
                  <path d="M20 7H4C2.89543 7 2 7.89543 2 9V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V9C22 7.89543 21.1046 7 20 7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 7V5C16 4.46957 15.7893 3.96086 15.4142 3.58579C15.0391 3.21071 14.5304 3 14 3H10C9.46957 3 8.96086 3.21071 8.58579 3.58579C8.21071 3.96086 8 4.46957 8 5V7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Productos</span>
              </Link>
              <Link to="/inventory-adjustments" className={`nav-item nav-subitem ${isActive("/inventory-adjustments")}`}>
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M12 8V12M12 16H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                <span>Descarga de Inventario</span>
              </Link>
            </div>

            <Link to="/suppliers" className={`nav-item ${isActive("/suppliers")}`}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M9 22V12H15V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Proveedores</span>
            </Link>
          </div>

          <div className="nav-divider"></div>

          {/* Reportes */}
          <div className="nav-section">
            <Link to="/reports" className={`nav-item ${isActive("/reports")}`}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M18 20V10M12 20V4M6 20V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Reportes</span>
            </Link>
          </div>

        </nav>

        <div style={{
          padding: '12px',
          borderTop: '1px solid rgba(255,255,255,0.1)',
          textAlign: 'center',
          fontSize: '11px',
          color: 'rgba(255,255,255,0.5)',
          marginTop: 'auto',
        }}>
          ⚡ ALTIVAWEB &nbsp;|&nbsp; 📞 6859-7183 &nbsp;|&nbsp; ✉️ altivaweb@gmail.com
        </div>
      </div>
    </>
  );
}